module.exports = __webpack_public_path__ + "static/media/geolocator_black.6151b80b.png";